/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Player_Record_Toggle_Aria_LabelInputs */

const en_player_record_toggle_aria_label = /** @type {(inputs: Player_Record_Toggle_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Record Toggle`)
};

const fr_player_record_toggle_aria_label = /** @type {(inputs: Player_Record_Toggle_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Basculer l'Enregistrement`)
};

const de_player_record_toggle_aria_label = /** @type {(inputs: Player_Record_Toggle_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aufnahme umschalten`)
};

const it_player_record_toggle_aria_label = /** @type {(inputs: Player_Record_Toggle_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Attiva/disattiva registrazione`)
};

const ru_player_record_toggle_aria_label = /** @type {(inputs: Player_Record_Toggle_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Переключить запись`)
};

const es_player_record_toggle_aria_label = /** @type {(inputs: Player_Record_Toggle_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alternar grabación`)
};

const zh_cn2_player_record_toggle_aria_label = /** @type {(inputs: Player_Record_Toggle_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`录制切换`)
};

const ja_player_record_toggle_aria_label = /** @type {(inputs: Player_Record_Toggle_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`記録切り替え`)
};

const hi_player_record_toggle_aria_label = /** @type {(inputs: Player_Record_Toggle_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`रिकॉर्ड टॉगल`)
};

const pt_pt2_player_record_toggle_aria_label = /** @type {(inputs: Player_Record_Toggle_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alternar gravação`)
};

/**
* | output |
* | --- |
* | "Record Toggle" |
*
* @param {Player_Record_Toggle_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const player_record_toggle_aria_label = /** @type {((inputs?: Player_Record_Toggle_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Player_Record_Toggle_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_player_record_toggle_aria_label(inputs)
	if (locale === "de") return de_player_record_toggle_aria_label(inputs)
	if (locale === "it") return it_player_record_toggle_aria_label(inputs)
	if (locale === "ru") return ru_player_record_toggle_aria_label(inputs)
	if (locale === "es") return es_player_record_toggle_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_player_record_toggle_aria_label(inputs)
	if (locale === "ja") return ja_player_record_toggle_aria_label(inputs)
	if (locale === "hi") return hi_player_record_toggle_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_player_record_toggle_aria_label(inputs)
	return en_player_record_toggle_aria_label(inputs)
});